module.exports = __webpack_public_path__ + "7158e77d5a19d242968b7797e97e9b4f.svg";